__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/bbba7aed7bfb385a878922bd49c6b2f2b3eae496b24fe27e622ebe4c/";